import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFreecodecampComponent } from './simple-icons-freecodecamp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFreecodecampComponent ],
    exports:      [ SimpleIconsFreecodecampComponent ],
    bootstrap:    []
})
export class SimpleIconsFreecodecampModule {}
